// mentor
import axios from '@/libs/api.request'
// 导师联系导师部门
export const subContactUs = data => {
  return axios.request({
    url: '/mentor/contactus',
    data,
    method: 'POST'
  })
}
// 联系导师记录
export const getContactUsPage = data => {
  return axios.request({
    url: '/mentor/contactus/page',
    data,
    method: 'POST'
  })
}
// 评论是否有帮助
export const getContactUsEvaluation = data => {
  return axios.request({
    url: '/mentor/contactus/evaluation',
    data,
    method: 'POST'
  })
}
// 导师填写自荐原因
export const mentorSaveReason = data => {
  return axios.request({
    url: '/mentor/request/auction/save/reason',
    data,
    method: 'POST'
  })
}
// 获取竞单信息
export const getAuctionInfo = data => {
  return axios.request({
    url: '/mentor/request/auction/auction/info',
    data,
    method: 'POST'
  })
}
